module.exports = {
  xxxl: 24,
  xxl: 22,
  xl: 20,
  lg: 18,
  md: 16,
  sm: 14,
  xs: 12,
  xxs: 10
};